import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_arrow-top-right",
  "use": "icon_arrow-top-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_arrow-top-right\"><path fill=\"currentColor\" d=\"m5.89254 17.3984-.35355.3536.7071.7071.35356-.3536-.70711-.7071Zm.70711.7071L17.9134 6.7918l-.7072-.70711L5.89254 17.3984l.70711.7071Z\" /><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"m9.26758 6.24609 8.29242.19285.1929 8.29246\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol